import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { RequestDetailsComponent } from './requests/request-details/request-details.component';
import { RequestsComponent } from './requests/requests.component';
import { AirlineSettingsComponent } from './settings/airline-settings/airline-settings.component';
import { ERateSheetComponent } from './settings/airline-settings/e-rate-sheet/e-rate-sheet.component';
import { BrokerSettingsComponent } from './settings/broker-settings/broker-settings.component';
import { CustomerSettingsComponent } from './settings/customer-settings/customer-settings.component';
import { GsaSettingsComponent } from './settings/gsa-settings/gsa-settings.component';
import { MainSettingsComponent } from './settings/main-settings/main-settings.component';
import { UserSettingsComponent } from './settings/user-settings/user-settings.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'customer-settings',
    component: CustomerSettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requests',
    component: RequestsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'airline-settings',
    component: AirlineSettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'eRateSheet/:id',
    component: ERateSheetComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'broker-settings',
    component: BrokerSettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'requests/:id',
    component: RequestDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gsa-settings',
    component: GsaSettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'user-settings',
    component: UserSettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'main-settings',
    component: MainSettingsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'login', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
